import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';

@Component({
  selector: 'x-profile-header',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './x-profile-header.component.html',
  styleUrl: './x-profile-header.component.scss',
})
export class XProfileHeaderComponent {
  displayName = input.required<string>();
  email = input.required<string>();
  initials = input('?');
  imageUrl = input<string | null>(null);

  readonly imageLoadFailed = signal(false);

  onImageError(): void {
    this.imageLoadFailed.set(true);
  }

  onImageLoad(): void {
    this.imageLoadFailed.set(false);
  }
}
